import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import RevenueOpportunityRecipientPresetForm from "routes/revenue_opportunity_recipient_presets/components/RevenueOpportunityRecipientPresetForm";

const RevenueOpportunityRecipientPresetModal = ({
  preset,
  open,
  onOpenChange,
  fetchPresets,
  onSuccess,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const actualOpen = isControlled ? open : internalOpen;
  const setOpen = isControlled ? onOpenChange : setInternalOpen;

  const handleSuccess = () => {
    setOpen(false);
    if (onSuccess) {
      onSuccess();
    } else if (fetchPresets) {
      fetchPresets();
    }
  };

  const header = `${preset ? "Edit" : "New"} Recipient Preset`;

  return (
    <Dialog open={actualOpen} onOpenChange={setOpen}>
      {!isControlled && (
        <DialogTrigger render={<Button size="sm">{header}</Button>} />
      )}
      <DialogContent>
        <DialogTitle>{header}</DialogTitle>
        <RevenueOpportunityRecipientPresetForm
          preset={preset}
          onSuccess={handleSuccess}
        />
      </DialogContent>
    </Dialog>
  );
};

export default RevenueOpportunityRecipientPresetModal;
